export const WAGE_TYPES = { hourlyPay: "HOURLY_WAGE", monthlyPay: "MONTHLY_WAGE", yearlyPay: "YEARLY_WAGE" }
